/* eslint-disable no-undef */
import NiceSelect from "nice-select2";

document.addEventListener('DOMContentLoaded', function () {
    console.log('inspiration');

    function niceSelect(selectId) {
        let select = document.getElementById(selectId);
  
        if (select) {
          const selectedOption = select.options[select.selectedIndex];
          const placeholderText = selectedOption && selectedOption.value ? selectedOption.value : 'Region';
        
          const options = {
            searchable: true,
            placeholder: placeholderText,
            searchtext: 'Välj',
          };
      
          let instance = new NiceSelect(select, options);
    
          setTimeout(() => {
            const searchInputs = document.querySelectorAll('.nice-select-search-box input');
            
            function normalizeText(text) {
              return text
                .replace(/\s+/g, '')
                .replace(/[üÜ]/g, 'u')
                .replace(/[öÖ]/g, 'o')
                .replace(/[äÄåÅ]/g, 'a')
                .toLowerCase();
            }
      
            searchInputs.forEach(input => {
              const list = input.closest('.nice-select').querySelector('.list');
              const listItems = list.querySelectorAll('li');
      
              input.addEventListener('input', function () {
                const searchValue = normalizeText(input.value);
      
                listItems.forEach(item => {
                  const text = normalizeText(item.textContent);
                  item.style.display = text.includes(searchValue) ? '' : 'none';
                });
              });
            });
          }, 100);
        } else {
          console.warn('No element found with ID:', selectId);
        }
    }

    // Initialize nice select for both forms
    niceSelect('dealers-region-form');
    niceSelect('campsites-region-form');

    function dealersReginSearch(){
        const btnSearch   = document.getElementById('dealers-search-btn');
        const selectField = document.getElementById('dealers-region-form');
      
        btnSearch.addEventListener('click', function(e) {
          e.preventDefault();

          let regionValue = selectField.value.trim();
      
          if (regionValue) {
            window.location.href = '/dealers/?region=' + encodeURIComponent(regionValue);
          } else {
            window.location.href = '/dealers/';
          }
        });
    }

    function campsitesRegionSearch(){
        const btnSearch   = document.getElementById('campsites-search-btn');
        const selectField = document.getElementById('campsites-region-form');
      
        btnSearch.addEventListener('click', function(e) {
          e.preventDefault();

          let regionValue = selectField.value.trim();
      
          if (regionValue) {
            window.location.href = '/campsite/?region=' + encodeURIComponent(regionValue);
          } else {
            window.location.href = '/campsite/';
          }
        });
    }

    dealersReginSearch();
    campsitesRegionSearch();
});
